export default __webpack_public_path__ + "static/media/hami_video_03.aa344d54.jpg";